module.exports = __webpack_public_path__ + "img/step_1.1f42f9d8.jpg";